export interface Article {
  slug: string;
  /** Explicit localized paths (EN slug can differ from FR slug). */
  frPath: string;
  enPath: string;
  image: string;
  fr: {
    title: string;
    subtitle: string;
    category: string;
    date: string;
    readingTime: string;
  };
  en: {
    title: string;
    subtitle: string;
    category: string;
    date: string;
    readingTime: string;
  };
}

export const articles: Article[] = [
  {
    slug: "comment-choisir-application-recus",
    frPath: "/blog/comment-choisir-application-recus",
    enPath: "/en/blog/how-to-choose-receipt-app",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80",
    fr: {
      title: "Comment choisir une application de reçus : 3 critères essentiels (2026)",
      subtitle:
        "Précision OCR, stockage cloud sécurisé, catégories et filtres : comment évaluer chaque critère, avec comparatif des applications populaires.",
      category: "Guide d'achat",
      date: "10 juillet 2026",
      readingTime: "9 min de lecture",
    },
    en: {
      title: "How to Choose a Receipt App: 3 Key Criteria (2026)",
      subtitle:
        "OCR accuracy, secure cloud storage, categories and filters: how to assess each criterion, with a comparison of the popular apps.",
      category: "Buying guide",
      date: "July 10, 2026",
      readingTime: "9 min read",
    },
  },
  {
    slug: "partager-recu-conjoint-famille",
    frPath: "/blog/partager-recu-conjoint-famille",
    enPath: "/en/blog/share-receipt-with-partner-family",
    image: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?w=800&q=80",
    fr: {
      title: "Comment partager un reçu avec son conjoint ou sa famille",
      subtitle:
        "Utile quand une personne est au magasin, mais que le reçu est dans le téléphone de l'autre.",
      category: "Guide",
      date: "14 juin 2026",
      readingTime: "5 min de lecture",
    },
    en: {
      title: "How to Share a Receipt With Your Partner or Family",
      subtitle:
        "Useful when one person is at the store but the receipt is on the other's phone.",
      category: "Guide",
      date: "June 14, 2026",
      readingTime: "5 min read",
    },
  },
  {
    slug: "meilleure-application-recus-canada",
    frPath: "/blog/meilleure-application-recus-canada",
    enPath: "/en/blog/best-receipt-app-canada",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    fr: {
      title: "Quelle est la meilleure application de reçus au Canada?",
      subtitle:
        "Comment choisir selon vos besoins : retours, garanties, recherche, famille ou dépenses.",
      category: "Comparatif",
      date: "13 juin 2026",
      readingTime: "7 min de lecture",
    },
    en: {
      title: "What Is the Best Receipt App in Canada?",
      subtitle:
        "How to choose based on your needs: returns, warranties, search, family or expenses.",
      category: "Comparison",
      date: "June 13, 2026",
      readingTime: "7 min read",
    },
  },
  {
    slug: "comment-faire-retour-magasin-avec-telephone",
    frPath: "/blog/comment-faire-retour-magasin-avec-telephone",
    enPath: "/en/blog/how-to-return-items-in-store-with-your-phone",
    image: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?w=800&q=80",
    fr: {
      title: "Comment faire un retour en magasin avec son téléphone",
      subtitle:
        "Retrouver le bon reçu, présenter l'image et afficher le code-barres quand disponible.",
      category: "Guide",
      date: "12 juin 2026",
      readingTime: "6 min de lecture",
    },
    en: {
      title: "How to Return Items in Store With Your Phone",
      subtitle:
        "Find the right receipt, present the image and show the barcode when available.",
      category: "Guide",
      date: "June 12, 2026",
      readingTime: "6 min read",
    },
  },
  {
    slug: "garantie-magasin-vs-garantie-manufacturier",
    frPath: "/blog/garantie-magasin-vs-garantie-manufacturier",
    enPath: "/en/blog/store-warranty-vs-manufacturer-warranty",
    image: "https://images.unsplash.com/photo-1556909212-d5b604d0c90d?w=800&q=80",
    fr: {
      title: "Garantie de satisfaction du magasin vs garantie du manufacturier",
      subtitle:
        "Le délai d'échange sur la facture (2 sem. à 3 mois) vs la garantie du fabricant, propre à chaque produit — et comment suivre les deux.",
      category: "Guide",
      date: "15 juin 2026",
      readingTime: "7 min de lecture",
    },
    en: {
      title: "Store Satisfaction Guarantee vs Manufacturer Warranty",
      subtitle:
        "The exchange window on the receipt (2 weeks to 3 months) vs the maker's warranty, specific to each product — and how to track both.",
      category: "Guide",
      date: "June 15, 2026",
      readingTime: "7 min read",
    },
  },
  {
    slug: "comment-conserver-recus-garanties",
    frPath: "/blog/comment-conserver-recus-garanties",
    enPath: "/en/blog/how-to-keep-receipts-for-warranties",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    fr: {
      title: "Comment conserver ses reçus pour les garanties",
      subtitle:
        "Garder la preuve d'achat au bon endroit aide à retrouver le reçu au moment d'une réclamation.",
      category: "Guide",
      date: "11 juin 2026",
      readingTime: "6 min de lecture",
    },
    en: {
      title: "How to Keep Receipts for Warranties",
      subtitle:
        "Keeping proof of purchase in the right place helps you find it when it is time for a claim.",
      category: "Guide",
      date: "June 11, 2026",
      readingTime: "6 min read",
    },
  },
  {
    slug: "recu-efface-quoi-faire",
    frPath: "/blog/recu-efface-quoi-faire",
    enPath: "/en/blog/faded-receipt-what-to-do",
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800&q=80",
    fr: {
      title: "Reçu effacé : quoi faire avec un reçu illisible?",
      subtitle:
        "Le papier thermique s'efface. Voici quoi faire et comment garder une preuve d'achat lisible.",
      category: "Guide",
      date: "10 juin 2026",
      readingTime: "5 min de lecture",
    },
    en: {
      title: "Faded Receipt: What to Do With an Unreadable Receipt",
      subtitle:
        "Thermal paper fades. Here is what to do and how to keep readable proof of purchase.",
      category: "Guide",
      date: "June 10, 2026",
      readingTime: "5 min read",
    },
  },
  {
    slug: "comment-numeriser-recus-application-mobile",
    frPath: "/blog/comment-numeriser-recus-application-mobile",
    enPath: "/en/blog/comment-numeriser-recus-application-mobile",
    image: "/images/blog/scan/scan-1.jpg",
    fr: {
      title: "Comment numériser des reçus avec une application mobile",
      subtitle:
        "Numériser ses reçus est l'une des façons les plus simples d'éviter de perdre ses preuves d'achat et de faciliter les retours et les garanties.",
      category: "Guide 2026",
      date: "4 juin 2026",
      readingTime: "8 min de lecture",
    },
    en: {
      title: "How to Scan Receipts with a Mobile App",
      subtitle:
        "Scanning your receipts is one of the simplest ways to avoid losing your proof of purchase and make returns and warranties easier.",
      category: "2026 Guide",
      date: "June 4, 2026",
      readingTime: "8 min read",
    },
  },
  {
    slug: "meilleure-app-recu-2026",
    frPath: "/blog/meilleure-app-recu-2026",
    enPath: "/en/blog/meilleure-app-recu-2026",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80",
    fr: {
      title:
        "Meilleure application de reçu en 2026 : pourquoi vous devriez arrêter de gérer vos factures comme un comptable",
      subtitle:
        "Une comparaison honnête des outils du marché — et pourquoi la majorité d'entre eux n'ont jamais été pensés pour vous.",
      category: "Comparatif 2026",
      date: "20 mai 2026",
      readingTime: "8 min de lecture",
    },
    en: {
      title:
        "Best Receipt App in 2026: Why You Should Stop Managing Your Invoices Like an Accountant",
      subtitle:
        "An honest comparison of available tools — and why most of them were never designed for you.",
      category: "2026 Comparison",
      date: "May 20, 2026",
      readingTime: "8 min read",
    },
  },
];
